import React, { Component } from 'react';

class Home extends Component {
	render() {
		return (
			<p className="App-intro">
				Para começar, edite <code>src/home/Home.jsx</code> e salve para recarregar.
			</p>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/modules/home/Home.jsx